import { GetOrganizationSurveys, GetSurveys } from '../../api';

// Types
import { TableQueryParams } from '../../types';

export async function fetchOrganizationSurveyData({ clientId }: { clientId?: string }) {
    if (clientId) {
        const allSurveys = await GetOrganizationSurveys({ orgId: clientId });

        if (allSurveys) {
            const { surveys } = allSurveys;

            return {
                rows: surveys
            };
        }
    }
    return {
        rows: []
    };
}

export async function fetchPaginatedSurveysData({ options }: { options: TableQueryParams }) {
    const allSurveys = await GetSurveys(options);

    if (allSurveys) {
        const { surveys, totalRecords } = allSurveys;

        return {
            rows: surveys,
            pageCount: Math.ceil(totalRecords / options.pageData.size)
        };
    } else {
        return {
            rows: [],
            pageCount: 0
        };
    }
}

// export async function fetchSurveyData() {
//     const allSurveys = await GetSurveys();

//     if (allSurveys) {
//         const { surveys } = allSurveys;

//         return {
//             rows: surveys
//         };
//     }
// }
